/** CSS contract: css-library/components/01-leaves/ki-label.css. */
import type { Ref } from 'react';
import { Tooltip } from './ButtonControl';

import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from '../lib/cx';
import { Icon } from './Icon';

export type KiLabelKind = 'generiert' | 'formuliert';

const DEFAULT_TEXT: Record<KiLabelKind, string> = {
  generiert: 'KI-generiert',
  formuliert: 'KI-formuliert',
};

const DEFAULT_TITLE: Record<KiLabelKind, string> = {
  generiert: 'Von KI erstellt – bitte prüfen.',
  formuliert: 'Von KI aus Ihrem Diktat formuliert – bitte prüfen.',
};

export interface KiLabelProps extends HTMLAttributes<HTMLSpanElement> {
  kind: KiLabelKind;
  children?: ReactNode;
  title?: string;
}

export function KiLabel(
  { ref, kind, className, children, title, ...rest }: KiLabelProps & { ref?: Ref<HTMLSpanElement> },
) {
  return (
    <Tooltip><span ref={ref} className={cx('ki-label', className)} title={title ?? DEFAULT_TITLE[kind]} {...rest}>
      <Icon name="i-sparkle" />
      {children ?? DEFAULT_TEXT[kind]}
    </span></Tooltip>
  );
}
